<template>
  <TableReference :lang="currlang" ></TableReference>
</template>

<script>
import TableReference from '@/components/TableReference.vue';
export default {
    name: "PageTableReference",
    components: {
        TableReference
    },
    data() {
      return {
         currlang : this.$route.params.lang
      }
    }
}
</script>

<style>

</style>